<template>
	<div class="shop-product-check">
		<b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false"></b-loading>
		<h1>Brand Price Adjustments</h1>

		<div class="content-wrapper">
			<div class="button-container" @click="addNew()">
				<div class="big-button">
					Add New
				</div>
			</div>
		</div>

		<div class="price-adjustment-table heartbeat-warpper header">
			<div>Name</div>
			<div>Brand</div>
			<div>Shops</div>
			<div>Type</div>
			<div>Values</div>
			<div>Status</div>
			<div>Edit</div>
		</div>

		<div v-if="adjustments.length > 0">
			<div v-for="(adjustment, index) of adjustments" :key="index" class="price-adjustment-table">
				<div class="header" @click="goTo(adjustment._id)"><a>{{ adjustment.name }}</a></div>
				<div>{{ adjustment.brand.name }} ( {{ adjustment.brand.code }})</div>
				<div>{{ adjustment.shopNames }}</div>
				<div>{{ adjustment.type }}</div>
				<div>{{ adjustment.value }}</div>
				<div>{{ statusText(adjustment.status) }}</div>
				<div class="header" @click="goTo(adjustment._id)"><a>Edit</a></div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	title: 'Brand Price Adjustments',
	name: 'brand-price-adjustments',
	data: () => ({
		limit: 20,
		isLoading: false,
		adjustments: []
	}),

	mounted: async function() {
		if (this.$store.state.auth) {
			this.$axios.defaults.headers.common['Authorization'] = 'Token ' + this.$store.state.auth
		}

		await this.getData()
	},

	computed: {},

	methods: {
		// Verify if the brand ID and values are valid
		heartbeat: async function() {
			return
		},

		addNew: function() {
			this.$router.push({ name: 'addBrandPriceAdjustment' })
		},

		goTo: function(id) {
			if (id) {
				this.$router.push({ name: 'editBrandPriceAdjustment', params: { id } })
			}
		},

		convertTime: function(time) {
			return this.$moment(time).fromNow()
		},

		statusText: function(status) {
			if (status) {
				return 'Enabled'
			} else {
				return 'Disabled'
			}
		},

		// Get list of data
		getData: async function() {
			const apiGetAdjustment = await this.$api.brandAdjustPriceList({
				data: { sort: { createdAt: 'desc' },populate: ['brand', 'shops'] }
			})

			// Extract shop names and join them with commas
			apiGetAdjustment.data.list.forEach(item => {
				// Extract shop names and join them with commas
				item.shopNames = item.shops.map(shop => shop.name).join(', ')
			})

			this.adjustments = apiGetAdjustment.data.list

			// this.shops = apiGetShops.data.list
		}
	}
}
</script>

<style scoped>
@import '../styles/GeneralStyles.css';
</style>
